import _ from 'underscore';

// this function can only handle float or int as input
// could not handle local numbers in string
export const countNumberOfDigits = (num) => {
  const decimal = num.toString().split('.')[1];

  return _.isUndefined(decimal) ? 0 : decimal.length;
};
